import React, {Component} from "react";
import PortalModal from "../../../../../common/PortalModal";
import { FormTextField } from "../../../../../common/Form/FormTextField";
import { Autocomplete, Chip, FormControl, Grid, InputLabel, TextField, Typography } from "@mui/material";
import { Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/pro-light-svg-icons";
import { hasDuplicate, isValidEmail, isValidEmails } from "./utils";
import PortalEmailsInput from "../../../../../common/PortalEmailsInput";
import { isError } from "lodash";

class AddAlternativeHosts extends Component {

    state = {
        inputValue: '',
        isError: false,
        errorMessage: {}
    }

    //Θ(1) Sets input value
    onChangeInputValue = (inputValue) => {
        this.setState({
            inputValue
        })
    }

    //Θ(1) Sets is error
    onChangeIsError = (isError, errorMessage = {}) => {
        this.setState({
            isError,
            errorMessage
        })
    }

    //Θ(1) Adds the alt hosts
    onAddHosts = () => {
        let hosts = this.props.altHosts;

        //In case of user doesn't hit space and there is an email to add in the textfield
        if(this.state.inputValue !== '' && isValidEmail(this.state.inputValue)) {
            hosts.push(this.state.inputValue)
            this.setState({
                inputValue: ''
            })
        } else if(this.state.inputValue !== '') {
            this.setState({
                isError: true
            })
            return;
        }
        
        this.props.addAltHost(hosts.join(";"));
    }

    render() {
        let {meeting} = this.props;

        const isEdit = meeting?.settings?.alternative_hosts.length > 0
        const isPrimaryButtonDisabled = this.props.isLoading || this.state.isError || (this.props.altHosts.length === 0 && this.state.inputValue.length === 0) || !isValidEmails([...this.props.altHosts, this.state.inputValue]) || hasDuplicate([...this.props.altHosts, this.state.inputValue])
        return <React.Fragment>
            <PortalModal
                maxWidth="md"
                onPrimaryClick={this.onAddHosts}
                onClose={this.props.toggleIsAddAltHostDisplay}
                isOpen={this.props.isAddAltHostDisplay}
                title = {isEdit ? 'Edit Alternative Hosts' : 'Add Alternative Host'}
                id="addAltHostModal"
                primaryButtonTitle={isEdit ? "Edit" : "Add"}
                isPrimaryButtonDisabled = {isPrimaryButtonDisabled}
                isCloseable={true}
                secondaryButtonTitle= "No, Cancel"
                onSecondaryClick={this.props.toggleIsAddAltHostDisplay}
            >
                <FormControl fullWidth >
                    <Grid container direction="column" gap={1} >
                        <Grid item xs={12}>
                            <Typography component="label" className="myOdu__label">
                                Alternative Host(s) Email
                            </Typography>
                        </Grid>
                        <Grid item>
                            <PortalEmailsInput 
                                altHosts = {this.props.altHosts}
                                inputValue = {this.state.inputValue}
                                isError = {this.state.isError}
                                onChangeAltHosts = {this.props.onChangeAltHosts}
                                onChangeInputValue = {this.onChangeInputValue}
                                onChangeIsError = {this.onChangeIsError}
                                errorMessage = {this.state.errorMessage}
                            />
                        </Grid>
                    </Grid>
                </FormControl>
            </PortalModal>
        </React.Fragment>
    }
}

export default AddAlternativeHosts;